/**
 * GENERATED by `bun run compare`. Do not edit. Sources live in docs/compare/.
 */
import type { ComparePage } from "./types.ts";

export const PAGES: readonly ComparePage[] = [
  {
    slug: "lattice-vs-function-health",
    former: "function-health",
    logo: "/logos/function-health.svg",
    other: "Function Health",
    otherUrl: "https://www.functionhealth.com/",
    headline: "Lattice is a $175 a month powder. Function Health is a $365 a year lab membership.",
    retrieved: "19 October 2026",
    order: 1,
    lead: [
      "Function Health is a lab membership. Lattice is a monthly powder a physician signs from labs you upload.",
      "Lattice does not book a blood draw.",
    ],
    rows: [
      {
        criterion: "What it is",
        lattice: "A physician-signed protein powder from your labs",
        other: "A membership for blood testing",
      },
      {
        criterion: "Price",
        lattice: "$175 a month",
        other: "$365 a year, paid once a year",
      },
      {
        criterion: "What you get",
        lattice: "One labelled pouch each month",
        other: "160+ lab tests, two draws a year",
      },
      {
        criterion: "Physician",
        lattice: "Reviews and signs every formula",
        other: "Clinicians review every result",
      },
      {
        criterion: "Labs from",
        lattice: "Labs you upload",
        other: "Quest, or a draw at home",
      },
      {
        criterion: "Charged",
        lattice: "After the physician approves your formula",
        other: "Once a year, at signup",
      },
    ],
    sections: [
      {
        id: "how-it-works",
        heading: "How it works",
        paragraphs: [
          "You test at a Quest site, or a specialist comes to you. Clinicians review every result. The page lists a plan with those results.",
          "Lattice starts with an upload. A physician reviews within 24 hours and signs a formula. The card is not charged before that signature.",
          "If your labs are all in range, we tell you so and add nothing for them. Protein and creatine are optional.",
        ],
      },
      {
        id: "insurance",
        heading: "Insurance",
        paragraphs: ["The Function Health pricing page says no insurance is required."],
      },
      {
        id: "skipping-and-cancelling",
        heading: "Skipping and cancelling",
        paragraphs: [
          "Lattice has no cancellation fee. Skip a month, pause for up to three months, or cancel from your account any time before the next renewal. A cancellation ends at the end of the month you have paid for.",
        ],
      },
    ],
    pickOther: "Choose Function Health if you still need labs. Lattice does not book a blood draw.",
    pickLattice:
      "Choose Lattice if you already have labs, from Function Health or elsewhere, and want one powder from those numbers.",
    sources: [
      "Function Health pricing page, https://www.functionhealth.com/pricing, retrieved 19 October 2026. Membership $365 a year, charged annually. 160+ lab tests a year. Testing twice a year and on demand. Clinicians review every result. Draw at Quest or at home.",
      "Lattice's own price of $175 a month and its 24 hour review, and the skip, pause, cancel and in-range terms, as set out by Lattice.",
    ],
  },
  {
    slug: "lattice-vs-superpower",
    former: "superpower",
    logo: "/logos/superpower.svg",
    other: "Superpower",
    otherUrl: "https://superpower.com/",
    headline: "Lattice is a $175 a month powder. Superpower is a $199 a year lab membership.",
    retrieved: "19 October 2026",
    order: 2,
    lead: [
      "Superpower is a yearly lab membership. Lattice is a monthly powder a physician signs from labs you already have.",
      "Superpower runs the draw. Lattice does not.",
    ],
    rows: [
      {
        criterion: "What it is",
        lattice: "A physician-signed protein powder from your labs",
        other: "A membership for blood testing",
      },
      {
        criterion: "Price",
        lattice: "$175 a month",
        other: "$199 a year. More in NY and NJ.",
      },
      {
        criterion: "What you get",
        lattice: "One labelled pouch each month",
        other: "100+ biomarkers from one draw",
      },
      {
        criterion: "Physician",
        lattice: "Reviews and signs every formula",
        other: "A care team, plus an AI named Kin",
      },
      {
        criterion: "Labs from",
        lattice: "Labs you upload",
        other: "A partner lab, or at home for a fee",
      },
      {
        criterion: "Results",
        lattice: "Formula within 24 hours of upload",
        other: "In the app in 10 days or less",
      },
    ],
    sections: [
      {
        id: "how-it-works",
        heading: "How it works",
        paragraphs: [
          "You book a draw at a partner lab. An at-home draw costs extra. The buy box says results in 10 days or less.",
          "A care team and an AI named Kin are in the app. The membership includes one blood test a year. Follow-up tests are add-ons.",
          "Lattice starts with an upload. A physician reviews within 24 hours and signs a formula.",
          "If your labs are all in range, we tell you so and add nothing for them. Protein and creatine are optional.",
        ],
      },
      {
        id: "price",
        heading: "Price",
        paragraphs: ["A note on the homepage says pricing may vary in New York and New Jersey."],
      },
      {
        id: "skipping-and-cancelling",
        heading: "Skipping and cancelling",
        paragraphs: [
          "You can cancel any time. The paid year stays active through its end.",
          "Lattice has no cancellation fee. Skip a month, pause for up to three months, or cancel from your account any time before the next renewal. A cancellation ends at the end of the month you have paid for.",
        ],
      },
    ],
    pickOther: "Choose Superpower if you still need a blood panel. Lattice does not run lab tests.",
    pickLattice:
      "Choose Lattice if you already have labs and want a powder a physician signs from them.",
    sources: [
      "Superpower homepage, https://superpower.com/, retrieved 19 October 2026. $199 a year. Pricing may vary in New York and New Jersey. 100+ biomarkers from one blood draw. Results in 10 days or less. At-home draw is an extra fee. One blood test a year is included. Follow-up tests are add-ons.",
      "Lattice's own price of $175 a month and its 24 hour review, and the skip, pause, cancel and in-range terms, as set out by Lattice.",
    ],
  },
  {
    slug: "lattice-vs-rythm",
    former: "rythm",
    logo: "/logos/rythm-ink.svg",
    other: "Rythm",
    otherUrl: "https://rythm.health/",
    headline: "Lattice is a $175 a month powder. Rythm is a $79 a month at-home blood test.",
    retrieved: "19 October 2026",
    order: 3,
    lead: [
      "Rythm is a monthly at-home blood test. Lattice is a monthly powder a physician signs from labs you already have.",
      "Rythm collects the sample. Lattice does not draw blood.",
    ],
    rows: [
      {
        criterion: "What it is",
        lattice: "A physician-signed protein powder from your labs",
        other: "A monthly at-home blood test",
      },
      {
        criterion: "Price",
        lattice: "$175 a month",
        other: "$79 a month, plus shipping and tax",
      },
      {
        criterion: "What you get",
        lattice: "One labelled pouch each month",
        other: "25+ biomarkers and an AI coach",
      },
      {
        criterion: "Physician",
        lattice: "Reviews and signs every formula",
        other: "A licensed physician signs each result",
      },
      {
        criterion: "Labs from",
        lattice: "Labs you upload",
        other: "Upper-arm kit with an FDA-cleared Tasso+",
      },
      {
        criterion: "Charged",
        lattice: "After the physician approves your formula",
        other: "On the day you order, then every 30 days",
      },
    ],
    sections: [
      {
        id: "how-it-works",
        heading: "How it works",
        paragraphs: [
          "The kit uses an FDA-cleared Tasso+ device. It is a capillary draw from the upper arm, not a vein draw at a clinic.",
          "The FAQ says results are live within 3 business days of the lab receiving the sample. The homepage also says results in less than 48 hours.",
          "A state-licensed physician signs each result before it is shown. Samples go to Rythm's own lab, listed as CLIA-certified and CAP-accredited.",
          "If your labs are all in range, we tell you so and add nothing for them. Protein and creatine are optional.",
        ],
      },
      {
        id: "price",
        heading: "Price",
        paragraphs: [
          "Shipping and tax are added at checkout. The help center says the total is around $100, and it varies by address.",
          "The homepage was showing 30% off the first test, at $55.30, on 19 October 2026. That discount is not the recurring price.",
        ],
      },
      {
        id: "skipping-and-cancelling",
        heading: "Skipping and cancelling",
        paragraphs: [
          "You can skip up to 90 days, and a skipped month is not charged. Cancel any time, with no fee.",
          "Lattice has no cancellation fee. Skip a month, pause for up to three months, or cancel from your account any time before the next renewal. A cancellation ends at the end of the month you have paid for.",
        ],
      },
    ],
    pickOther:
      "Choose Rythm if you want monthly at-home labs and you do not yet have results. Lattice does not draw blood.",
    pickLattice:
      "Choose Lattice if you already have labs, from Rythm or elsewhere, and want a powder a physician signs from them.",
    sources: [
      "Rythm homepage, https://rythm.health/, retrieved 19 October 2026. 25+ biomarkers. $79 a test, plus shipping and tax. First test shown at $55.30 with 30% off. The page also says results in less than 48 hours.",
      "Rythm FAQ, https://rythmhealth.com/faq, retrieved 19 October 2026. Charged on the order day, then every 30 days. Results show within 3 business days of the lab receiving the sample. A state-licensed physician signs each result. Collection uses an FDA-cleared Tasso+ device. Skip up to 90 days. Cancel with no fee. Available in all 50 states. Own lab, CLIA-certified and CAP-accredited.",
      "Rythm help center pricing article, https://support.rythmhealth.com/en/articles/17589226-pricing-taxes-discounts-promotions-and-referrals, retrieved 19 October 2026. Standard price is $79 a month. Shipping and tax are extra. The final total is around $100 and varies by address.",
      "Lattice's own price of $175 a month and its 24 hour review, and the skip, pause, cancel and in-range terms, as set out by Lattice.",
    ],
  },
  {
    slug: "lattice-vs-ag1",
    former: "ag1",
    logo: "/logos/ag1.svg",
    other: "AG1",
    otherUrl: "https://drinkag1.com/",
    headline:
      "Lattice is a $175 a month powder made from your labs. AG1 is a $79 a month greens powder.",
    retrieved: "19 October 2026",
    order: 4,
    lead: [
      "AG1 is one greens powder for every customer. Lattice is a monthly powder a physician signs from your labs.",
      "The subscription is $79 a month. It does not use your lab numbers.",
    ],
    rows: [
      {
        criterion: "What it is",
        lattice: "A physician-signed protein powder from your labs",
        other: "One greens powder for every customer",
      },
      {
        criterion: "Price",
        lattice: "$175 a month",
        other: "$79 a month on subscription",
      },
      {
        criterion: "What you get",
        lattice: "Protein plus supplements in one pouch",
        other: "75+ ingredients in one scoop",
      },
      {
        criterion: "Physician",
        lattice: "Reviews and signs every formula",
        other: "No review of your labs",
      },
      {
        criterion: "Built from",
        lattice: "Your lab results and a short intake",
        other: "One Next Gen formula",
      },
      {
        criterion: "Testing",
        lattice: "A pharmacy makes each pouch for you",
        other: "NSF Certified for Sport",
      },
    ],
    sections: [
      {
        id: "how-it-works",
        heading: "How it works",
        paragraphs: [
          "AG1 ships the same pouch each month. You can pause or cancel any time.",
          "Lattice starts with an upload and a short intake. A physician reviews within 24 hours. A pharmacy then makes your pouch.",
          "If your labs are all in range, we tell you so and add nothing for them. Protein and creatine are optional.",
        ],
      },
      {
        id: "certification",
        heading: "Certification",
        paragraphs: [
          "Each batch carries NSF Certified for Sport. NSF still listed AG1 Next Gen on 19 October 2026.",
        ],
      },
      {
        id: "skipping-and-cancelling",
        heading: "Skipping and cancelling",
        paragraphs: [
          "Lattice has no cancellation fee. Skip a month, pause for up to three months, or cancel from your account any time before the next renewal. A cancellation ends at the end of the month you have paid for.",
        ],
      },
    ],
    pickOther: "Choose AG1 if you want one scoop, a lower monthly price, and no lab upload.",
    pickLattice:
      "Choose Lattice if you have labs and want a physician to sign a powder built from them.",
    sources: [
      "AG1 discounts page, https://drinkag1.com/discounts, retrieved 19 October 2026. Next Gen subscription $79 a month. One-time purchase listed at $99.",
      "AG1 product page, https://drinkag1.com/products/drinkag1, retrieved 19 October 2026. 75+ ingredients. NSF Certified for Sport.",
      "NSF listings, https://info.nsf.org/Certified/Dietary/Listings.asp?CompanyName=ag1, current as of 19 October 2026. AG1 Next Gen is listed.",
      "Lattice's own price of $175 a month and its physician review, and the skip, pause, cancel and in-range terms, as set out by Lattice.",
    ],
  },
  {
    slug: "lattice-vs-seed",
    former: "seed",
    logo: "/logos/seed.svg",
    other: "Seed",
    otherUrl: "https://seed.com/daily-synbiotic",
    headline: "Lattice is a $175 a month powder. Seed is a $49.99 a month capsule.",
    retrieved: "19 October 2026",
    order: 5,
    lead: [
      "Seed DS-01 is a synbiotic in two capsules a day. Lattice is a monthly protein powder a physician signs from your labs.",
      "The Seed page lists trials of that one formula. Lattice is mixed from your labs.",
    ],
    rows: [
      {
        criterion: "What it is",
        lattice: "A physician-signed protein powder from your labs",
        other: "A daily synbiotic in two capsules",
      },
      {
        criterion: "Price",
        lattice: "$175 a month",
        other: "$49.99 a month",
      },
      {
        criterion: "What you get",
        lattice: "Protein plus supplements in one pouch",
        other: "24 strains plus a prebiotic",
      },
      {
        criterion: "Physician",
        lattice: "Reviews and signs every formula",
        other: "No review of your labs",
      },
      {
        criterion: "Built from",
        lattice: "Your lab results and a short intake",
        other: "One formula for every adult",
      },
      {
        criterion: "Evidence",
        lattice: "Each pouch follows a signed formula",
        other: "Full-formula trials listed for DS-01",
      },
    ],
    sections: [
      {
        id: "how-it-works",
        heading: "How it works",
        paragraphs: [
          "Seed ships 60 capsules a month. The dose is two capsules a day. You can pause or cancel any time.",
          "Lattice starts with an upload. A physician reviews within 24 hours. A pharmacy then makes your pouch.",
          "If your labs are all in range, we tell you so and add nothing for them. Protein and creatine are optional.",
        ],
      },
      {
        id: "refunds",
        heading: "Refunds",
        paragraphs: [
          "The first order has a 30-day refund. Later shipments sit outside that window.",
        ],
      },
      {
        id: "skipping-and-cancelling",
        heading: "Skipping and cancelling",
        paragraphs: [
          "Lattice has no cancellation fee. Skip a month, pause for up to three months, or cancel from your account any time before the next renewal. A cancellation ends at the end of the month you have paid for.",
        ],
      },
    ],
    pickOther: "Choose Seed if you want a studied synbiotic and you do not need a protein powder.",
    pickLattice:
      "Choose Lattice if you have labs and want a physician to sign a powder built from them.",
    sources: [
      "Seed DS-01 page, https://seed.com/daily-synbiotic, retrieved 19 October 2026. $49.99 a month. 24 strains. Two capsules a day. Full-formula trials. 30-day refund on the first order only.",
      "Lattice's own price of $175 a month and its physician review, and the skip, pause, cancel and in-range terms, as set out by Lattice.",
    ],
  },
  {
    slug: "lattice-vs-custom-powder",
    former: "custom-powder",
    logo: "/logos/custom-powder.svg",
    other: "Quiz-based custom powders",
    otherUrl: "https://www.topvitamine.com/blogs/news/personalized-vitamin-subscriptions",
    headline:
      "Lattice is a $175 a month powder from your labs. A quiz pack is about $28 to $100 a month.",
    retrieved: "19 October 2026",
    order: 6,
    lead: [
      "Most quiz-based custom powders are chosen from a quiz. Some shops blend a formula to order.",
      "Lattice is a monthly powder a physician signs from labs you upload.",
    ],
    rows: [
      {
        criterion: "What it is",
        lattice: "A physician-signed protein powder from your labs",
        other: "A quiz pack or a blended formula",
      },
      {
        criterion: "Price",
        lattice: "$175 a month",
        other: "About $28 to $100 a month",
      },
      {
        criterion: "What you get",
        lattice: "Protein plus supplements in one pouch",
        other: "Daily packs, often without protein",
      },
      {
        criterion: "Physician",
        lattice: "Reviews and signs every formula",
        other: "Often a quiz. Sometimes a nutritionist.",
      },
      {
        criterion: "Built from",
        lattice: "Your lab results and a short intake",
        other: "Quiz answers, sometimes an at-home test",
      },
      {
        criterion: "Charged",
        lattice: "After the physician approves your formula",
        other: "Often at signup",
      },
    ],
    sections: [
      {
        id: "how-it-works",
        heading: "How it works",
        paragraphs: [
          "A quiz ends in a monthly pack. Doses come from the answers, and sometimes a nutritionist reviews them.",
          "Lattice takes an upload and a short intake. A physician has 24 hours to sign the formula.",
          "If your labs are all in range, we tell you so and add nothing for them. Protein and creatine are optional.",
        ],
      },
      {
        id: "price",
        heading: "Price",
        paragraphs: [
          "Compounded blends ran about $60 to $100 a month. These are one reviewer's figures, not shop price pages, and promos change.",
        ],
      },
      {
        id: "skipping-and-cancelling",
        heading: "Skipping and cancelling",
        paragraphs: [
          "Lattice has no cancellation fee. Skip a month, pause for up to three months, or cancel from your account any time before the next renewal. A cancellation ends at the end of the month you have paid for.",
        ],
      },
    ],
    pickOther: "Choose a quiz pack if you want a lower price and you do not have labs to upload.",
    pickLattice: "Choose Lattice if you have labs and want a physician to sign a powder from them.",
    sources: [
      "Topvitamine roundup, updated 17 October 2026, https://www.topvitamine.com/blogs/news/personalized-vitamin-subscriptions, retrieved 19 October 2026. Seven services priced from about $28 to $100 a month. Nurish at $28 to $40. Persona at $45 to $90. Compounded blends at $60 to $100.",
      "Lattice's own price of $175 a month and its physician review, and the skip, pause, cancel and in-range terms, as set out by Lattice.",
    ],
  },
];
